
import { Language } from '@/types/language';

// Import main site translations
import en from './en';
import it from './it';
import es from './es';
import de from './de';
import tr from './tr';


// Import backoffice translations using correct exports
import { backofficeEn } from '../backoffice/en';
import { backofficeIt } from '../backoffice/it';
import { backofficeEs } from '../backoffice/es';
import { backofficeDe } from '../backoffice/de';
import { backofficeTr } from '../backoffice/tr';


const translations: Record<Language, Record<string, any>> = {
  en: { ...en, ...backofficeEn },
  it: { ...it, ...backofficeIt },
  es: { ...es, ...backofficeEs },
  de: { ...de, ...backofficeDe },
  tr: { ...tr, ...backofficeTr },
  
};

export default translations;
